import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import InternalChatView from './InternalChatView.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.INTERNAL_CHAT,
  permissions: ['administrator', 'agent'],
};

const internalChatRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/internal-chat'),
      name: 'internal_chat',
      component: InternalChatView,
      meta,
    },
    {
      path: frontendURL('accounts/:accountId/internal-chat/:chatId'),
      name: 'internal_chat_detail',
      component: InternalChatView,
      props: true,
      meta,
    },
  ],
};

export default internalChatRoutes;
